const administracionDeSubmenus = {
    AgregarNuevoSubmenuPW: 'SICPO/AdministracionDeSubmenusPW/AgregarNuevoSubmenu',
    ObtenerSubmenusPW: 'SICPO/AdministracionDeSubmenusPW/ObtenerSubmenusPaginaWeb',
    CambiarEstatusDeSubmenusPW: 'SICPO/AdministracionDeSubmenusPW/CambiarEstatusDeSubmenusPaginaWeb',
    ModificarSubmenuPW: 'SICPO/AdministracionDeSubmenusPW/ModificarSubmenu',
    ModificarOrdenamientoDeSubmenusPW: 'SICPO/AdministracionDeSubmenusPW/ModificarOrdenamientoDeSubmenus',
    OrdenarAlfabeticamenteSubmenusPW: 'SICPO/AdministracionDeSubmenusPW/OrdenarAlfabeticamenteSubmenus'
}

export default administracionDeSubmenus;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/administracionDeSubmenus/administracionDeSubmenus.js
// module id = null
// module chunks = 